import { Directive, OnInit, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';



/**
 * Usage:
 *
 * <img [image-loader]="object.id" [file]="file" imageUrl="url" imageType="VENDOR_PROFILE" />
 */
@Directive({
  selector: '[appImageLoader]',
  // tslint:disable-next-line:no-host-metadata-property
  host: {
    '[src]': 'sanitizer.bypassSecurityTrustUrl(imageData)'
  }
})
export class ImageLoaderDirective implements OnInit {

  url: string;
  apiUrl: string;
  imageData: any;
  sanitzedImageData: any;

  // @Input('appImageLoader') vendorId: number;
  // tslint:disable-next-line:no-input-rename
  @Input('appImageLoader') imageUrl: string;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    // this.imageData = 'src/assets/no-image-produto.jpeg';

    // if (this.vendorId ) {
    // if (this.imageType === 'VENDOR_PROFILE') {
    // this.url = environment.imageType[this.imageType].replace('{id}', '' + this.vendorId);
    // }

    // this.url = this.apiUrl + this.url;
    console.log('IMAGEM:' + this.imageUrl);

    this.http.get<any>(this.imageUrl)
      .subscribe(
        data => {

          const mimeType = data.mimeType;
          this.imageData = 'data:' + mimeType + ';base64,' + data.imageContent;

        },
        (err: HttpErrorResponse) => {
          if (err.status !== 200) {
            // console.log('ERRO AO CARREGAR IMAGEM:' + err.status);
            // this.http.get('assets/images/produto-sem-imagem.png', { responseType: 'blob' })
            //   .subscribe(res => {
            //     const reader = new FileReader();
            //     reader.onloadend = () => {
            //       this.imageData = reader.result;
            //     }
            //     reader.readAsDataURL(res);
            //   });
            // }

            this.imageData = 'https://infokaw.com.br/downloads/no-image.jpeg'

            // if (err.error instanceof Error) {
            //   // A client-side or network error occurred. Handle it accordingly.
            //   console.log('Error fetching image:', err.error.message);
            // } else {
            //   // normally this happens if the object returned is not of json format
            //   // this can cause quite the trouble
            //   console.log(`Error fetching image: code=${err.status}, message=${err.error}`);
            // }
          }
        }
      );
    // }

  }

  private createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageData = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
      console.log(reader.readAsDataURL(image));
    }
  }
}


